export const MortgageApplicationTabNames = {
  YOUR_MORTGAGE: 'yourMortgage',
  APPLICANT: 'applicant',
  APPLICANT_TAB: 'applicantTab',
  YOUR_OUTGOINGS: 'yourOutgoings',
  YOUR_PROPERTY: 'yourProperty',
  FF2: 'factFind2'
};
